/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
} from './Lead';

/**
 * 
 * @export
 * @interface CreateLead201Response
 */
export interface CreateLead201Response {
    /**
     * 
     * @type {Lead}
     * @memberof CreateLead201Response
     */
    data?: Lead;
}

/**
 * Check if a given object implements the CreateLead201Response interface.
 */
export function instanceOfCreateLead201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLead201ResponseFromJSON(json: any): CreateLead201Response {
    return CreateLead201ResponseFromJSONTyped(json, false);
}

export function CreateLead201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLead201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LeadFromJSON(json['data']),
    };
}

export function CreateLead201ResponseToJSON(value?: CreateLead201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadToJSON(value.data),
    };
}

